import myAPI from './resources'
import config from '../config'

export default {
  getAll: function () {
    return myAPI.get(config.api_root + config.api_root_path_admin + '/restrictions')
      .then(function (response) {
        return response
      })
  },
  create: function (restriction) {
    return myAPI.post(config.api_root + config.api_root_path_admin + '/restrictions', restriction)
      .then(function (response) {
        return response
      })
  },
  update: function (restriction) {
    return myAPI.put(config.api_root + config.api_root_path_admin + '/restrictions', restriction)
      .then(function (response) {
        return response
      })
  },
  delete (id) {
    return myAPI.delete(`${config.api_root}${config.api_root_path_admin}/restrictions/${id}`)
      .then(result => {
        return result
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/restrictions.js